import { render, staticRenderFns } from "./Integration2.vue?vue&type=template&id=7162f5d4"
import script from "./Integration2.vue?vue&type=script&lang=js"
export * from "./Integration2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports